"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var COMPLAINTS_FETCH_PENDING = exports.COMPLAINTS_FETCH_PENDING = "COMPLAINTS_FETCH_PENDING";
var COMPLAINTS_FETCH_COMPLETE = exports.COMPLAINTS_FETCH_COMPLETE = "COMPLAINTS_FETCH_COMPLETE";
var COMPLAINTS_FETCH_COMPLETE_UPDATE = exports.COMPLAINTS_FETCH_COMPLETE_UPDATE = "COMPLAINTS_FETCH_COMPLETE_UPDATE";
var COMPLAINTS_FETCH_CLOSE_COMPLETE = exports.COMPLAINTS_FETCH_CLOSE_COMPLETE = "COMPLAINTS_FETCH_CLOSE_COMPLETE";
var COMPLAINTS_FETCH_ERROR = exports.COMPLAINTS_FETCH_ERROR = "COMPLAINTS_FETCH_ERROR";
var COMPLAINTS_CATEGORIES_FETCH_SUCCESS = exports.COMPLAINTS_CATEGORIES_FETCH_SUCCESS = "COMPLAINTS_CATEGORIES_FETCH_SUCCESS";
var COMPLAINTS_CATEGORIES_FETCH_ERROR = exports.COMPLAINTS_CATEGORIES_FETCH_ERROR = "COMPLAINTS_CATEGORIES_FETCH_ERROR";
var COMPLAINTS_SORT_ORDER = exports.COMPLAINTS_SORT_ORDER = "COMPLAINTS_SORT_ORDER";
var COMPLAINTS_SEND_MESSAGE = exports.COMPLAINTS_SEND_MESSAGE = "COMPLAINTS_SEND_MESSAGE";
var COMPLAINTS_SEND_MESSAGE_SHAREMEDIA = exports.COMPLAINTS_SEND_MESSAGE_SHAREMEDIA = "COMPLAINTS_SEND_MESSAGE_SHAREMEDIA";
var COMPLAINTS_SEND_MESSAGE_SHARECONTENT_TO = exports.COMPLAINTS_SEND_MESSAGE_SHARECONTENT_TO = "COMPLAINTS_SEND_MESSAGE_SHARECONTENT_TO";
var COMPLAINTS_DEPARTMENT_FETCH_SUCCESS = exports.COMPLAINTS_DEPARTMENT_FETCH_SUCCESS = "COMPLAINTS_DEPARTMENT_FETCH_SUCCESS";
var COMPLAINTS_DEPARTMENT_FETCH_ERROR = exports.COMPLAINTS_DEPARTMENT_FETCH_ERROR = "COMPLAINTS_DEPARTMENT_FETCH_ERROR";
var COMPLAINTS_SECTOR_FETCH_SUCCESS = exports.COMPLAINTS_SECTOR_FETCH_SUCCESS = "COMPLAINTS_SECTOR_FETCH_SUCCESS";
var COMPLAINTS_SECTOR_FETCH_ERROR = exports.COMPLAINTS_SECTOR_FETCH_ERROR = "COMPLAINTS_SECTOR_FETCH_ERROR";
var COMPLAINTS_AUTOROUTING_FETCH_SUCCESS = exports.COMPLAINTS_AUTOROUTING_FETCH_SUCCESS = "COMPLAINTS_AUTOROUTING_FETCH_SUCCESS";
var COMPLAINTS_AUTOROUTING_FETCH_ERROR = exports.COMPLAINTS_AUTOROUTING_FETCH_ERROR = "COMPLAINTS_AUTOROUTING_FETCH_ERROR";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/complaints/actionTypes.js
// module id = 1720
// module chunks = 895